import React, { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PageLoader from '../../@jumbo/components/PageComponents/PageLoader';

const Dashboards = ({ match }) => {
    const requestedUrl = match.url.replace(/\/$/, '');
    return (
        <Suspense fallback={<PageLoader />}>
            <Switch>
                <Redirect exact from={`${requestedUrl}/`} to={`${requestedUrl}/manage-account-facebook`} />
                <Route
                    path={`${requestedUrl}/manage-account-facebook`}
                    component={lazy(() => import('./manage-account-facebook'))}
                />
                <Route path={`${requestedUrl}/manage-script`} component={lazy(() => import('./manage-script'))} />
                <Route path={`${requestedUrl}/manage-posts`} component={lazy(() => import('./manage-posts'))} />
                <Route path={`${requestedUrl}/manage-groups`} component={lazy(() => import('./manage-groups'))} />
                <Route path={`${requestedUrl}/manage-group-fb-joined`} component={lazy(() => import('./manage-group-joined'))} />
                <Route path={`${requestedUrl}/manage-question-group`} component={lazy(() => import('./manage-question-group'))} />
                <Route path={`${requestedUrl}/manage-logs`} component={lazy(() => import('./manage-logs'))} />
                <Route path={`${requestedUrl}/manage-proxies`} component={lazy(() => import('./manage-proxy'))} />

                <Route component={lazy(() => import('../Pages/404'))} />
            </Switch>
        </Suspense>
    );
};

export default Dashboards;
